import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findbindPromoters = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agentPromotion/promotionList?` + params,
        method: 'GET'
    })
}

export const findUserList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
        method: 'GET'
    })
}
export const addbindPromoters = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agentPromotion/register`,
        method: 'POST',
        data: params
    })
}
export const bindPromoters = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agentPromotion/binding/${ids}`,
        method: 'GET',
    })
}
export const delbindPromoters = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agentPromotion/unbind/${ids}`,
        method: 'GET',
    })
}
// 获取推广员报名列表
export const getPromotionList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/enroll?` + params,
        method: 'GET'
    })
}
//标记已联系
export const markContact = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/enroll/${id}`,
        method: 'PUT',
    })
}